import React from 'react';
import styled from '@emotion/styled';
import { Css, Flex, H3 } from '../../../../../ui';
import { Color } from '../../../../shared/styles/Color';
import Responsive from '../../../../../ui/utils/Responsive';

const StyledSocialCard = styled(Flex)`
	flex-direction: column;
	width: 100%;
	height: 100%;
	background-color: ${Color.BackgroundWhite};
	border-radius: ${Css.pxToRem(12)};
	padding: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		padding-left: ${Css.pxToRem(16)};
		padding-right: ${Css.pxToRem(16)};
		border-radius: 0;
	}
`;

const StyledTitle = styled(H3)`
	color: ${Color.TextBlack};
`;

const StyledTitleWrapper = styled(Flex)`
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	align-items: flex-start;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		flex-direction: column;
	}
`;

export const SocialCard = ({
	children,
	title,
	endContent,
}: React.PropsWithChildren<{
	title: string;
	endContent?: React.ReactNode;
}>) => (
	<StyledSocialCard>
		<StyledTitleWrapper>
			<StyledTitle styling="h4">{title}</StyledTitle>
			{endContent}
		</StyledTitleWrapper>
		{children}
	</StyledSocialCard>
);
